import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// Load cart from localStorage
const loadCart = () => {
  try {
    const cart = localStorage.getItem('cart');
    return cart ? JSON.parse(cart) : [];
  } catch (error) {
    console.error('Error loading cart from localStorage:', error);
    return [];
  }
};

// Load auth state - now session-based
const loadAuth = () => {
  return {
    token: null,
    user: null,
    isAuthenticated: false
  };
};

const store = new Vuex.Store({
  state: {
    cart: loadCart(),
    auth: loadAuth()
  },
  mutations: {
    // Auth mutations - now session-based
    SET_AUTH(state, { token, user, isAuthenticated }) {
      state.auth.token = token;
      state.auth.user = user;
      state.auth.isAuthenticated = isAuthenticated !== undefined ? isAuthenticated : !!user;
    },
    CLEAR_AUTH(state) {
      state.auth.token = null;
      state.auth.user = null;
      state.auth.isAuthenticated = false;
    },
    // Cart mutations
    ADD_TO_CART(state, product) {
      const existingProduct = state.cart.find(item => item.id === product.id);
      if (existingProduct) {
        existingProduct.quantity++;
      } else {
        state.cart.push({
          ...product,
          quantity: 1
        });
      }
      // Save to localStorage
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },
    REMOVE_FROM_CART(state, productId) {
      state.cart = state.cart.filter(item => item.id !== productId);
      // Save to localStorage
      localStorage.setItem('cart', JSON.stringify(state.cart));
    },
    UPDATE_QUANTITY(state, { productId, quantity }) {
      const product = state.cart.find(item => item.id === productId);
      if (product) {
        product.quantity = quantity;
        // Save to localStorage
        localStorage.setItem('cart', JSON.stringify(state.cart));
      }
    },
    CLEAR_CART(state) {
      state.cart = [];
      // Clear localStorage
      localStorage.removeItem('cart');
    },
    // New mutation to update cart from storage event
    UPDATE_CART_FROM_STORAGE(state, cart) {
      state.cart = cart;
    }
  },
  getters: {
    cartItemCount: state => {
      return state.cart.reduce((total, item) => total + item.quantity, 0);
    },
    cartTotal: state => {
      return state.cart.reduce((total, item) => {
        const price = parseFloat(item.price.replace(/[^0-9.-]+/g, ''));
        return total + (price * item.quantity);
      }, 0);
    },
    isAuthenticated: state => state.auth.isAuthenticated,
    currentUser: state => state.auth.user,
    token: state => state.auth.token
  }
});

// Listen for storage events from other tabs
window.addEventListener('storage', (event) => {
  if (event.key === 'cart') {
    try {
      const newCart = event.newValue ? JSON.parse(event.newValue) : [];
      store.commit('UPDATE_CART_FROM_STORAGE', newCart);
    } catch (error) {
      console.error('Error parsing cart from storage event:', error);
    }
  }
});

export default store; 